import { Formik } from "formik";
import { Divider, Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";

type Values = {
    id: number | undefined,
    rut: string,
    email: string,
    iduser_type: number | undefined,
    password: string,
    status_confirm: string
}

export const UserModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, rowSelected, clearState } = props;

    const [data, setData] = useState<Values>({
        id: rowSelected ? rowSelected.id :'',
        rut: rowSelected ? rowSelected.rut :'',
        email: rowSelected ? rowSelected.email :'',
        iduser_type: rowSelected ? rowSelected.iduser_type :'',
        password: rowSelected ? rowSelected.password :'',
        status_confirm: rowSelected ? (rowSelected.status_confirm == '1' ? 'Confirmado' : 'No confirmado') :'',
    });

    const validateForm = (values) => {}

    const onSubmit = async(values)  => {}

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="sm">
            <ModalHeader
                text={'Detalle de usuario'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px' >
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{"Rut"}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="rut"
                                            variant="standard"
                                            type="text" 
                                            name="rut"
                                            multiline
                                            fullWidth
                                            value={values.rut}
                                            placeholder={"rut"}
                                            inputProps={{ readOnly: true }}
                                        />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px' >
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{"Correo"}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="email"
                                            variant="standard"
                                            type="text" 
                                            name="email"
                                            multiline
                                            fullWidth
                                            value={values.email}
                                            placeholder={"email"}
                                            inputProps={{ readOnly: true }}
                                        />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px' >
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{"Estado"}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="status_confirm"
                                            variant="standard"
                                            type="text" 
                                            name="status_confirm"
                                            multiline
                                            fullWidth
                                            value={values.status_confirm}
                                            placeholder={"status_confirm"}
                                            inputProps={{ readOnly: true }}
                                        />
                                        </Grid>
                                    </Grid>
                                
                                </Grid>

                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    cancelText={"Cancelar"}
                                    onCancel={closeModal}
                                />
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}